import React, { Suspense, lazy } from 'react';
import "@/App.css";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Hero } from "./components/Hero";
import { HowItWorks } from "./components/HowItWorks";
import { TrustStats } from "./components/TrustStats";
import { ProblemTypes } from "./components/ProblemTypes";
import { CTABanner } from "./components/CTABanner";
import { Services } from "./components/Services";
import { FAQ } from "./components/FAQ";
import { CTASection } from "./components/CTASection";
import { Footer } from "./components/Footer";

// Lazy Loaded Routes
const CobrarPage = lazy(() => import("./components/CobrarPage").then(module => ({ default: module.CobrarPage })));
const AconteceuPage = lazy(() => import("./components/AconteceuPage").then(module => ({ default: module.AconteceuPage })));
const ExtratoV2Page = lazy(() => import("./components/extrato-v2/ExtratoV2Page").then(module => ({ default: module.ExtratoV2Page })));
const ExtratoPage = lazy(() => import("./components/extrato/ExtratoPage").then(module => ({ default: module.ExtratoPage })));
const RecuperarPage = lazy(() => import("./components/RecuperarPage").then(module => ({ default: module.RecuperarPage })));
const PoliticaPrivacidadePage = lazy(() => import("./components/PoliticaPrivacidadePage").then(module => ({ default: module.PoliticaPrivacidadePage })));
const NotFoundPage = lazy(() => import("./components/NotFoundPage").then(module => ({ default: module.NotFoundPage })));

const SuspenseFallback = () => (
  <div className="min-h-screen bg-slate-50 flex items-center justify-center">
    <div className="w-8 h-8 rounded-full border-4 border-slate-200 border-t-blue-600 animate-spin"></div>
  </div>
);

const HomePage = ({ video = false }) => (
  <div className="App min-h-screen bg-slate-50">
    <main>
      <Hero video={video} />
      <HowItWorks />
      <TrustStats />
      <ProblemTypes />
      <CTABanner />
      <Services />
      <FAQ />
      <CTASection />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <Suspense fallback={<SuspenseFallback />}>
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{ style: { fontWeight: 500 } }}
      />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cobrar" element={<CobrarPage />} />
        <Route path="/v2" element={<HomePage video />} />
        <Route path="/cobrar-v2" element={<CobrarPage video />} />
        <Route path="/aconteceu-v2" element={<AconteceuPage video />} />
        <Route path="/recuperar-v2" element={<RecuperarPage video />} />
        <Route path="/extrato" element={<ExtratoPage />} />
        <Route path="/extrato-v2" element={<ExtratoV2Page />} />
        <Route path="/aconteceu" element={<AconteceuPage />} />
        <Route path="/recuperar" element={<RecuperarPage />} />
        <Route path="/politica-de-privacidade" element={<PoliticaPrivacidadePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}

export default App;
